
import React from "react";
import { Grid } from "@mui/material";
import { IoLogOutOutline } from "react-icons/io5";
import { LogoutUser } from "../../Components/Helpers/Api";
import CustomModal from "../../Components/Modal/CustomModal";
import { GreenColorButton, PrimeGrayBorderColorButton } from "../../Components/MaterialButtonStyle/StyleButton";


const LogoutModal = ({ logoutModal, setLogoutModal }) => {
  const LogoutData = () => {
    setLogoutModal(false);
    LogoutUser()
  };
  return (
    <CustomModal
      open={logoutModal}
      setOpen={setLogoutModal}
      divider={false}
      header={false}
      modalTitle={""}
      width={window.innerWidth > 600 ? "25%" : "95%"}
      modalContent={<Grid
        item
        container
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <IoLogOutOutline color={"#0FBE7C"} size={80} />
        <p className="poppinsRegular pt-3 text-center" style={{ color: "#171717" }}>Do you want to logout?</p>
        <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
          <PrimeGrayBorderColorButton
            type="submit"
            className="px-5 py-2"
            onClick={() => setLogoutModal(false)}
          >
            No
          </PrimeGrayBorderColorButton>
          <GreenColorButton
            type="submit"
            className="px-3 py-2 ml-3"
            onClick={() => LogoutData()}
          >
            Yes, Logout
          </GreenColorButton>
        </Grid>
      </Grid>
      }
    />
  )
}
export default LogoutModal;